"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.getConfigurationLib = exports.setConfigurationLib = void 0;
const wm_portal_lib_api_core_1 = require("@webmotors/wm-portal-lib-api-core");
_a = (0, wm_portal_lib_api_core_1.createConfiguration)({
    baseURLFairs: '',
}), exports.setConfigurationLib = _a.setConfigurationLib, exports.getConfigurationLib = _a.getConfigurationLib;
//# sourceMappingURL=index.js.map